// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

export interface TranslationDetails {
    key: string;
    values: { [k: string]: string};
}

// Returns the key matching the translation and object of named values as needed for the translation
function translateMessage(message?: string): TranslationDetails | undefined;
function translateMessage(message?: string, defaultTranslationKey?: string): TranslationDetails;
function translateMessage(message?: string, defaultTranslationKey?: string): any {
    const values: any = {};
    const defaultReturnValue = defaultTranslationKey
        ? {
            values,
            key: defaultTranslationKey,
        } : undefined;
    
    if (!message) {
        return defaultReturnValue;
    }
    
    let key = undefined;
    let match = null;
    if (match = message.match(/.*VERSION NAME (.*) OF THE DEFECTIVE COMPONENT (.*) IS NOT EQUAL TO THE VERSION NAME (.*) OF.*REPLACEMENT COMPONENT (.*)/i)) {
        key = 'component_replacement_version_not_equal';
        values.componentDeviceVersion = match[1];
        values.componentDeviceKey = match[2];
        values.replaceDeviceVersion = match[3];
        values.replaceDeviceKey = match[4];
    } else if (match = message.match(/COULD NOT GET.* OF THE DEVICE BEING REPAIRED.*SERIAL NUMBER (.*)/i)) {
        key = 'error_device_repair_querying_with_sn';
        values.serialNumber = match[1];
    } else if (match = message.match(/COULD NOT GET ADDRESS DETAILS.* JARVIS RETURNED NO VALID ADDRESSES.* OWNERID (.*)/i)) {
        key = 'jarvis_no_address_owner_id';
        values.ownerId = match[1];
    } else if (match = message.match(/COULD NOT GET ADDRESS DETAILS.* JARVIS RETURNED NO VALID CUSTOMERS.* PASSPORTUNIQUEID (.*)/i)) {
        key = 'jarvis_no_customers_passport_id';
        values.passportUniqueId = match[1];
    } else if (match = message.match(/(.*) CONTAINS INVALID CHARACTERS.* VALID CHARACTERS ARE (.*)/i)) {
        key = 'field_has_invalid_chars';
        values.field = match[1];
        values.validChars = match[2];
    } else if (match = message.match(/(.*) CAN\'T HAVE THESE INVALID CHARACTERS: (.*)\./i)) {
        key = 'field_cannot_have_invalid_chars';
        values.field = match[1];
        values.invalidChars = match[2];
    } else if (match = message.match(/.*ARGUMENT (.*) CANNOT BE NULL.*/i)) {
        key = 'fields_must_be_provided';
        values.fields = match[1];
    } else if (match = message.match(/(.*)MUST BE PROVIDED.*/i)) {
        key = 'fields_must_be_provided';
        values.fields = match[1];
    } else if (message.toUpperCase().includes('PAYMENT GATEWAY CANNOT BE NC') && message.toUpperCase().includes('CLAIM ORDER HAS PAID LINE ITEM')) {
        key = 'payment_cannot_nc_paid_line_items';
    }
    
    return key
        ? {
            key,
            values,
        } : defaultReturnValue;
}

export { translateMessage };
export default translateMessage;
